export const Ticket = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_383_6039)">
      <path
        d="M10.5 0H8.16667V0.583333C8.16667 0.892753 8.04375 1.1895 7.82496 1.40829C7.60616 1.62708 7.30942 1.75 7 1.75C6.69058 1.75 6.39383 1.62708 6.17504 1.40829C5.95625 1.1895 5.83333 0.892753 5.83333 0.583333V0H3.5C3.03587 0 2.59075 0.184374 2.26256 0.512563C1.93437 0.840752 1.75 1.28587 1.75 1.75V14H5.83333V13.4167C5.83333 13.1072 5.95625 12.8105 6.17504 12.5917C6.39383 12.3729 6.69058 12.25 7 12.25C7.30942 12.25 7.60616 12.3729 7.82496 12.5917C8.04375 12.8105 8.16667 13.1072 8.16667 13.4167V14H12.25V1.75C12.25 1.28587 12.0656 0.840752 11.7374 0.512563C11.4092 0.184374 10.9641 0 10.5 0ZM9.25983 12.8333C9.13092 12.3319 8.83892 11.8877 8.42981 11.5704C8.02069 11.2532 7.5177 11.081 7 11.081C6.4823 11.081 5.97931 11.2532 5.57019 11.5704C5.16108 11.8877 4.86908 12.3319 4.74017 12.8333H2.91667V9.91667H4.66667V8.75H2.91667V1.75C2.91667 1.59529 2.97812 1.44692 3.08752 1.33752C3.19692 1.22812 3.34529 1.16667 3.5 1.16667H4.74017C4.86908 1.66806 5.16108 2.11234 5.57019 2.42957C5.97931 2.7468 6.4823 2.91897 7 2.91897C7.5177 2.91897 8.02069 2.7468 8.42981 2.42957C8.83892 2.11234 9.13092 1.66806 9.25983 1.16667H10.5C10.6547 1.16667 10.8031 1.22812 10.9125 1.33752C11.0219 1.44692 11.0833 1.59529 11.0833 1.75V8.75H9.33333V9.91667H11.0833V12.8333H9.25983Z"
        fill="currentColor"
      />
      <path d="M8.16683 8.75H5.8335V9.91667H8.16683V8.75Z" fill="#706A85" />
    </g>
    <defs>
      <clipPath id="clip0_383_6039">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
